import React from 'react';
import { Box, Typography, Avatar, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// MOCK utilisateur connecté et ses clubs
const userMock = {
    id: 1,
    prenom: 'Mateo',
    clubs: [
        {
            id: 101,
            nom: 'Club Andinismo Cusco',
            ville: 'Cusco',
            sport: 'Football',
            logo: null,
        },
        {
            id: 102,
            nom: 'Lima Running Team',
            ville: 'Lima',
            sport: 'Basketball',
            logo: null,
        },
    ],
};

const AdminDashboard = () => {
    const navigate = useNavigate();
    return (
        <Box>
            <Typography variant="h4" fontWeight={700} gutterBottom sx={{ mb: 3, textAlign: 'left' }}>
                Dashboard
            </Typography>
            {userMock.clubs.length === 0 ? (
                <Typography color="text.secondary" sx={{ mt: 2 }}>
                    You do not own any club yet.
                </Typography>
            ) : (
                <Box sx={{
                    maxHeight: 600,
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    pr: 1,
                }}>
                    {userMock.clubs.map((club) => (
                        <Box key={club.id} sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1,
                            borderRadius: 3,
                            boxShadow: '0 2px 12px rgba(229,62,62,0.08)',
                            background: '#fafafa',
                            gap: 2,
                        }}>
                            <Avatar sx={{ bgcolor: '#FF6B6B', width: 48, height: 48, fontWeight: 700, fontSize: 22 }}>
                                {club.nom.charAt(0)}
                            </Avatar>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography variant="h6" fontWeight={700} noWrap>{club.nom}</Typography>
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {club.ville} · {club.sport}
                                </Typography>
                            </Box>
                            <Button variant="outlined" color="error" sx={{ borderRadius: 2, fontWeight: 600, textTransform: 'none', px: 3, minWidth: 0, fontSize: 15 }}
                                onClick={() => navigate(`/admin-panel/club/${club.id}`)}
                            >
                                Manage
                            </Button>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default AdminDashboard; 